"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.actions.run': '运行测试',
    'botTest.actions.results': '查看结果',
};
